export const Places = [
    {state: "CMDX", locations:[
        {address: "Jaime Balmes 11, local 146, 1er piso. Polanco I Sección", name: "Polanco", image:"polanco"},
        {address: "Paseo de las Palmas 735, piso 14 consultorio 04 Lomas de Chapultepec III Sección", name:"Chapultepec", image:"palmas"},
        {address: "Varsovia 36, Piso 5. Juárez, 06600.", name:"Varsovia", image:"juarez"},
        {address: "Av. Insurgentes Nte. 601, Piso 11 Nápoles", name:"Napoles", image:"insurgentes"},
        {address: "Av. Javier Barros 495, Piso 5", name:"Santa Fé", image:"santafe"},
    ]},
    {state: "Estado de México", locations:[
        {address: "Torre de Especialidades Médicas Arcángel Av. Lic. Benito Juárez García 504, int. 10 San Mateo", name:"Metepec", image:"metepec"},
        {address: "Centro afiliado Tlalnepantla de Baz", name:"Satélite", image:"satelite"}
    ]}
    ,
    {state: "Baja California Norte", locations:[
        {address: "Centro comercial moroli, Paseo de los Héroes 10201 Zona Urbana Rio Tijuana", name:"Tijuana", image:"tijuana"},
    ]},
    {state: "Nuevo León", locations:[
        {address: "Río Ganges 195, Del Valle Sector Fátima San Pedro Garza García", name:"Monterrey", image:"monterrey"},
    ]},
    {state: "Quintana Roo", locations:[
        {address: "Centro afiliado Kukulkan Lote 11, La Isla Zona Hotelera", name:"Cancún", image:"cancun"},
    ]},
    {state: "Queretaro", locations:[
        {address: "Av. Armando Birlain 2001 corporativo (Piso 1) 15 A. Central Park Col. Centro Sur CP 76090.", name:"Queretaro", image:"queretaro"},
    ]},
    {state: "Puebla", locations:[
        {address: "Pop-up Store - Regus Triángulo Las Animas, piso 5 oficina 513, Calle 39 Poniente 3515, Colonia Las Animas, 72400.", name:"Puebla", image:"puebla"},
    ]},
    {state: "Jalisco", locations:[
        {address: "Pop-up store - Av. Adolfo López Mateos Nte 95, Oficina 24-103. Italia Providencia CP. 44648.", name:"Guadalajara", image:"guadalajara"},
    ]},
    {state: "Guanajuato", locations:[
        {address: "KD Digital - Constructores #102, Esq. Juan Baustista De La Salle. Col. Panorama, 37160.", name:"León", image:"leon"},
    ]},
    {state: "Yucatán", locations:[
        {address: "Raydent - Calle 31 #89 Local 3 x 14 y 16. Colonia México, 97125.", name:"Mérida", image:"merida"},
    ]}
]


// WEBPACK FOOTER //
// ./src/configurations/Places.js